// module imports
import crypto from 'crypto';

export const generateVerificationToken = () => crypto.randomBytes(20).toString('hex');

export const formatDate = (dateString: string): string => {
  try {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return dateString;
  }
};

export const slugify = (text: string): string => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

const formatDateForEvent = (date: Date): string => {
  return date.toISOString().split('T')[0].replace(/-/g, '');
};

export const generateEventSlug = (title: string, date: Date): string => {
  const titleSlug = slugify(title);
  const formattedDate = formatDateForEvent(date);
  return `${titleSlug}-${formattedDate}`;
};
